jQuery.fn.extend( {
	accordion: function ( options = {} ) {
		return this.each( function ( accordionIndex ) {
			var accordionID = 'accordion-' + +accordionIndex,
				$accordion = $( this ).attr( 'id', accordionID ),
				$headings = $('.accordion__button', $accordion)
					.each(function (headingIndex) {
						$(this)
							.attr('id', accordionID + '-heading-' + +headingIndex)
							.attr('aria-expanded', false)
							.attr('aria-controls', accordionID + '-body-' + +headingIndex)
							.siblings('.accordion-body')
								.attr('id', accordionID + '-body-' + +headingIndex)
								.attr('aria-labelledby', accordionID + '-heading-' + +headingIndex)
								.attr('aria-hidden', true);

					}),
				$bodies = $( '.accordion-body', $accordion );

			$headings.unbind( 'click' )
				.on('click', function () {
					console.log( 'click' );
					var
						$heading = $(this).children( '.accordion-heading' ).first()
							.toggleClass(function () {
								console.log( 'toggle' );
								var $this = $(this);

								$this.parent().attr('aria-expanded', ! $this.hasClass('active') );

								return 'active';
							}),
						$body = $heading.parent().siblings('.accordion-body')
							.slideToggle(function () {
								var $this = $(this);

								$this.attr('aria-hidden', $this.is(':hidden'));
							});

					$headings.not($heading.parent())
						.attr('aria-expanded', false)
						.children( '.accordion-heading.active' )
						.removeClass('active');
					$bodies.not($body)
						.slideUp()
						.attr('aria-hidden', true);
				});
		});
	}
} );



// WEBPACK FOOTER //
// ./assets/js/components/extensions/jquery.accordion.js